(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SpadBack", [], factory);
	else if(typeof exports === 'object')
		exports["SpadBack"] = factory();
	else
		root["SpadBack"] = factory();
})(window, function() {
return 